import UserTransmissionrequest from './transmission-request';

export default class UserTransmissionrequestDesktop extends UserTransmissionrequest {
}
